var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form-item",
        {
          attrs: {
            label: _vm.$t("common.EnabledOrNot"),
            prop: "status",
            "label-width": _vm.formLabelWidth
          }
        },
        [
          _c("el-switch", {
            model: {
              value: _vm.formData.status,
              callback: function($$v) {
                _vm.$set(_vm.formData, "status", $$v)
              },
              expression: "formData.status"
            }
          })
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          staticClass: "must",
          attrs: {
            label: _vm.$t("common.PromotionCountry"),
            "label-width": _vm.formLabelWidth
          }
        },
        [
          _c(
            "div",
            [
              _c(
                "el-checkbox-group",
                {
                  model: {
                    value: _vm.formData.countryCode,
                    callback: function($$v) {
                      _vm.$set(_vm.formData, "countryCode", $$v)
                    },
                    expression: "formData.countryCode"
                  }
                },
                _vm._l(_vm.formData.countryCodes, function(item, index) {
                  return _c(
                    "el-checkbox",
                    {
                      key: index,
                      attrs: { label: item },
                      on: {
                        change: function(val) {
                          return _vm.handleTabCode(val, item)
                        }
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$dict.getDictValue("countrys", item)) +
                          "\n                "
                      )
                    ]
                  )
                }),
                1
              )
            ],
            1
          )
        ]
      ),
      _vm.formData.promotionRuleCountrys &&
      _vm.formData.promotionRuleCountrys.length > 0
        ? _c(
            "div",
            [
              _c(
                "el-tabs",
                {
                  staticClass: "country-tabs",
                  on: { "tab-click": _vm.changeCountrys },
                  model: {
                    value: _vm.formData.activeName,
                    callback: function($$v) {
                      _vm.$set(_vm.formData, "activeName", $$v)
                    },
                    expression: "formData.activeName"
                  }
                },
                _vm._l(_vm.formData.promotionRuleCountrys, function(
                  item,
                  index
                ) {
                  return _c(
                    "el-tab-pane",
                    {
                      key: index,
                      attrs: {
                        label: _vm.$dict.getDictValue(
                          "countrys",
                          item.countryCode
                        ),
                        name: item.countryCode
                      }
                    },
                    [
                      _c(
                        "el-form",
                        {
                          ref: "variantFrom",
                          refInFor: true,
                          attrs: { model: item, rules: _vm.rulesP }
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("common.Promotiontime"),
                                prop: "time",
                                "label-width": _vm.formLabelWidth
                              }
                            },
                            [
                              _c("el-date-picker", {
                                attrs: {
                                  clearable: "",
                                  type: "datetimerange",
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                  format: "yyyy-MM-dd HH:mm:ss",
                                  "range-separator": _vm.$t("common.to"),
                                  "start-placeholder": _vm.$t(
                                    "common.Startdate"
                                  ),
                                  "end-placeholder": _vm.$t("common.Enddate"),
                                  "default-time": ["00:00:00", "23:59:59"]
                                },
                                on: { input: _vm.changeCheckList },
                                model: {
                                  value: item.time,
                                  callback: function($$v) {
                                    _vm.$set(item, "time", $$v)
                                  },
                                  expression: "item.time"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "common.Displaypromotionalprices"
                                ),
                                "label-width": _vm.formLabelWidth
                              }
                            },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  on: {
                                    change: function(val) {
                                      return _vm.handlePriceTypep(
                                        val,
                                        item,
                                        index
                                      )
                                    }
                                  },
                                  model: {
                                    value: item.flagShowPromotionPrice,
                                    callback: function($$v) {
                                      _vm.$set(
                                        item,
                                        "flagShowPromotionPrice",
                                        $$v
                                      )
                                    },
                                    expression: "item.flagShowPromotionPrice"
                                  }
                                },
                                [
                                  _c("el-radio", { attrs: { label: false } }, [
                                    _vm._v(_vm._s(_vm.$t("common.No")))
                                  ]),
                                  _c("el-radio", { attrs: { label: true } }, [
                                    _vm._v(_vm._s(_vm.$t("common.Yes")))
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("common.PromotionPrice"),
                                "label-width": _vm.formLabelWidth
                              }
                            },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  on: {
                                    change: function(val) {
                                      return _vm.handlePriceTypep(
                                        val,
                                        item,
                                        index
                                      )
                                    }
                                  },
                                  model: {
                                    value: item.promotionType,
                                    callback: function($$v) {
                                      _vm.$set(item, "promotionType", $$v)
                                    },
                                    expression: "item.promotionType"
                                  }
                                },
                                [
                                  _c(
                                    "el-radio",
                                    { attrs: { label: "Discount" } },
                                    [_vm._v(_vm._s(_vm.$t("common.discount")))]
                                  ),
                                  _c(
                                    "el-radio",
                                    { attrs: { label: "Price" } },
                                    [_vm._v(_vm._s(_vm.$t("common.price")))]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          item.promotionType == "Discount"
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "",
                                    prop: "promotionValue",
                                    "label-width": _vm.formLabelWidth
                                  }
                                },
                                [
                                  _c("span", [_vm._v(" - ")]),
                                  _c("el-input", {
                                    style: { width: _vm.inputWidth },
                                    attrs: {
                                      oninput:
                                        "value=value.replace(/[^0-9.]/g,'')",
                                      placeholder: _vm.$t("common.discount")
                                    },
                                    on: {
                                      input: _vm.changeCheckList,
                                      blur: function($event) {
                                        return _vm.handleDiscount(item)
                                      }
                                    },
                                    model: {
                                      value: item.promotionValue,
                                      callback: function($$v) {
                                        _vm.$set(item, "promotionValue", $$v)
                                      },
                                      expression: "item.promotionValue"
                                    }
                                  }),
                                  _vm._v(
                                    "\n                        % off\n                    "
                                  )
                                ],
                                1
                              )
                            : item.promotionType == "Price"
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "",
                                    prop: "promotionValue",
                                    "label-width": _vm.formLabelWidth
                                  }
                                },
                                [
                                  _c("el-input", {
                                    style: { width: _vm.inputWidth },
                                    attrs: {
                                      oninput:
                                        "value=((value.replace(/[^0-9.]/g,'')).replace(/([0-9]+\\.[0-9]{2})[0-9]*/,'$1'))",
                                      placeholder: _vm.$t(
                                        "common.PleaseEnterThePrice"
                                      )
                                    },
                                    on: {
                                      input: _vm.changeCheckList,
                                      blur: function($event) {
                                        return _vm.handlePricep(item)
                                      }
                                    },
                                    model: {
                                      value: item.promotionValue,
                                      callback: function($$v) {
                                        _vm.$set(item, "promotionValue", $$v)
                                      },
                                      expression: "item.promotionValue"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label:
                                  item.promotionType == "Discount"
                                    ? _vm.$t("common.Promotionprice1")
                                    : _vm.$t("common.PromotionDiscount"),
                                "label-width": _vm.formLabelWidth
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: item.promotionValue,
                                      expression: "item.promotionValue"
                                    }
                                  ]
                                },
                                [
                                  _vm.isEdit
                                    ? _c("div", [
                                        _c(
                                          "div",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value:
                                                  item.promotionType ==
                                                  "Discount",
                                                expression:
                                                  "item.promotionType == 'Discount'"
                                              }
                                            ]
                                          },
                                          [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(item.discount) +
                                                "\n                                "
                                            )
                                          ]
                                        )
                                      ])
                                    : _c("div", [
                                        _c(
                                          "div",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value:
                                                  item.promotionType ==
                                                  "Discount",
                                                expression:
                                                  "item.promotionType == 'Discount'"
                                              }
                                            ]
                                          },
                                          [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(
                                                  _vm.Discount
                                                    ? _vm.Discount
                                                    : 0
                                                ) +
                                                "\n                                "
                                            )
                                          ]
                                        )
                                      ]),
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: item.promotionType == "Price",
                                          expression:
                                            "item.promotionType == 'Price'"
                                        }
                                      ]
                                    },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(item.Price) +
                                          "\n                            "
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: !item.promotionValue,
                                      expression: "!item.promotionValue"
                                    }
                                  ]
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            item.promotionType == "Discount",
                                          expression:
                                            "item.promotionType == 'Discount'"
                                        }
                                      ]
                                    },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(_vm.discountTip) +
                                          "\n                            "
                                      )
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: item.promotionType == "Price",
                                          expression:
                                            "item.promotionType == 'Price'"
                                        }
                                      ]
                                    },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(_vm.priceTip) +
                                          "\n                            "
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("common.Grossmargin"),
                                "label-width": _vm.formLabelWidth
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: item.promotionValue,
                                      expression: "item.promotionValue"
                                    }
                                  ]
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(item.profit) +
                                      "%\n                        "
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: !item.promotionValue,
                                      expression: "!item.promotionValue"
                                    }
                                  ]
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            item.promotionType == "Discount",
                                          expression:
                                            "item.promotionType == 'Discount'"
                                        }
                                      ]
                                    },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(_vm.discountTip) +
                                          "\n                            "
                                      )
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: item.promotionType == "Price",
                                          expression:
                                            "item.promotionType == 'Price'"
                                        }
                                      ]
                                    },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(_vm.priceTip) +
                                          "\n                            "
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("common.Promotionquantity"),
                                prop: "promotionCount",
                                "label-width": _vm.formLabelWidth
                              }
                            },
                            [
                              _c("el-input", {
                                staticClass: "input-width",
                                attrs: {
                                  oninput: "value=value.replace(/[^0-9]/g,'')",
                                  placeholder: _vm.$t(
                                    "common.PleaseEnterThePromotionalQuantity"
                                  )
                                },
                                on: {
                                  input: _vm.changeCheckList,
                                  blur: function($event) {
                                    return _vm.handlePromotionCount(item)
                                  }
                                },
                                model: {
                                  value: item.promotionCount,
                                  callback: function($$v) {
                                    _vm.$set(item, "promotionCount", $$v)
                                  },
                                  expression: "item.promotionCount"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("common.VirtualQuantity"),
                                prop: "virtualQty",
                                "label-width": _vm.formLabelWidth
                              }
                            },
                            [
                              _c("el-input", {
                                staticClass: "input-width",
                                attrs: {
                                  oninput:
                                    "value=value.replace(/[^0-9]/g,'');if(value && value.length>9)value=value.slice(0,9)",
                                  placeholder: _vm.$t(
                                    "common.PleaseEnterVirtualQuantity"
                                  )
                                },
                                on: { input: _vm.changeCheckList },
                                model: {
                                  value: item.virtualQty,
                                  callback: function($$v) {
                                    _vm.$set(item, "virtualQty", $$v)
                                  },
                                  expression: "item.virtualQty"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "valid-data-form-item",
                              attrs: { "label-width": "80px" }
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticStyle: { color: "red" },
                                  attrs: { slot: "label" },
                                  slot: "label"
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(_vm.$t("common.Verification")) +
                                      "\n                        "
                                  )
                                ]
                              ),
                              _c(
                                "span",
                                { staticStyle: { "font-size": "12px" } },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "common.PromotionQuantityPackageQuantity"
                                        )
                                      ) + ":"
                                    )
                                  ]),
                                  _c("span", { staticClass: "margin-5" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.calDivisorValue(
                                          item.promotionCount,
                                          _vm.getGoodsQuantity(
                                            item,
                                            _vm.formData.pageDataSelectList[0]
                                              .goodsSpecials
                                          )
                                        )
                                      )
                                    )
                                  ]),
                                  _c("span", { staticClass: "margin-10" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "common.VirtualQuantityPackageQuantity"
                                        )
                                      ) + ":"
                                    )
                                  ]),
                                  _c("span", { staticClass: "margin-5" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.calDivisorValue(
                                          item.virtualQty,
                                          _vm.getGoodsQuantity(
                                            item,
                                            _vm.formData.pageDataSelectList[0]
                                              .goodsSpecials
                                          )
                                        )
                                      )
                                    )
                                  ]),
                                  _c("span", { staticClass: "margin-10" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("common.VirtualSalesVolume")
                                      ) + ":"
                                    )
                                  ]),
                                  _c("span", { staticClass: "margin-5" }, [
                                    _vm._v(
                                      _vm._s(_vm.calVirtualSales(item, true))
                                    )
                                  ]),
                                  _c("span", { staticClass: "margin-10" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "common.VirtualSalesVolumePackageQuantity"
                                        )
                                      ) + ":\n                            "
                                    )
                                  ]),
                                  _c("span", { staticClass: "margin-5" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.calDivisorValue(
                                          _vm.calVirtualSales(item, true),
                                          _vm.getGoodsQuantity(
                                            item,
                                            _vm.formData.pageDataSelectList[0]
                                              .goodsSpecials
                                          )
                                        )
                                      )
                                    )
                                  ])
                                ]
                              )
                            ]
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("common.NumberOfUserPurchases"),
                                prop: "userBuy",
                                "label-width": _vm.formLabelWidth
                              }
                            },
                            [
                              _c("el-input", {
                                staticClass: "input-width",
                                attrs: {
                                  placeholder: _vm.$t(
                                    "common.AfterEnteringThePromotionalQuantityItWillBeAutomaticallyCalculatedBasedOnTheQuantityOfGoods"
                                  ),
                                  disabled: true
                                },
                                on: { input: _vm.changeCheckList },
                                model: {
                                  value: item.userBuy,
                                  callback: function($$v) {
                                    _vm.$set(item, "userBuy", $$v)
                                  },
                                  expression: "item.userBuy"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("common.Freeshippingornot"),
                                prop: "freeDelivery",
                                "label-width": _vm.formLabelWidth
                              }
                            },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  on: { change: _vm.changeCheckList },
                                  model: {
                                    value: item.freeDelivery,
                                    callback: function($$v) {
                                      _vm.$set(item, "freeDelivery", $$v)
                                    },
                                    expression: "item.freeDelivery"
                                  }
                                },
                                [
                                  _c("el-radio", { attrs: { label: true } }, [
                                    _vm._v(_vm._s(_vm.$t("common.Yes")))
                                  ]),
                                  _c("el-radio", { attrs: { label: false } }, [
                                    _vm._v(_vm._s(_vm.$t("common.No")))
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "common.Doyousupporttheuseofcoupons"
                                ),
                                "label-width": _vm.formLabelWidth
                              }
                            },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  model: {
                                    value: item.coupon,
                                    callback: function($$v) {
                                      _vm.$set(item, "coupon", $$v)
                                    },
                                    expression: "item.coupon"
                                  }
                                },
                                [
                                  _c("el-radio", { attrs: { label: true } }, [
                                    _vm._v(_vm._s(_vm.$t("common.Yes")))
                                  ]),
                                  _c("el-radio", { attrs: { label: false } }, [
                                    _vm._v(_vm._s(_vm.$t("common.No")))
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("common.Isitaflashkill"),
                                "label-width": _vm.formLabelWidth
                              }
                            },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  on: {
                                    change: _vm.changeCheckList,
                                    input: function($event) {
                                      return _vm.handleSeckill(item)
                                    }
                                  },
                                  model: {
                                    value: item.seckill,
                                    callback: function($$v) {
                                      _vm.$set(item, "seckill", $$v)
                                    },
                                    expression: "item.seckill"
                                  }
                                },
                                [
                                  _c("el-radio", { attrs: { label: true } }, [
                                    _vm._v(_vm._s(_vm.$t("common.Yes")))
                                  ]),
                                  _c("el-radio", { attrs: { label: false } }, [
                                    _vm._v(_vm._s(_vm.$t("common.No")))
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("common.SoldOutOrNot"),
                                "label-width": _vm.formLabelWidth
                              }
                            },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  on: { change: _vm.changeCheckList },
                                  model: {
                                    value: item.soldOut,
                                    callback: function($$v) {
                                      _vm.$set(item, "soldOut", $$v)
                                    },
                                    expression: "item.soldOut"
                                  }
                                },
                                [
                                  _c("el-radio", { attrs: { label: true } }, [
                                    _vm._v(_vm._s(_vm.$t("common.Yes")))
                                  ]),
                                  _c("el-radio", { attrs: { label: false } }, [
                                    _vm._v(_vm._s(_vm.$t("common.No")))
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("common.CountdownTimer"),
                                "label-width": _vm.formLabelWidth
                              }
                            },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  model: {
                                    value: item.showCountdown,
                                    callback: function($$v) {
                                      _vm.$set(item, "showCountdown", $$v)
                                    },
                                    expression: "item.showCountdown"
                                  }
                                },
                                [
                                  _c("el-radio", { attrs: { label: true } }, [
                                    _vm._v(_vm._s(_vm.$t("common.Yes")))
                                  ]),
                                  _c("el-radio", { attrs: { label: false } }, [
                                    _vm._v(_vm._s(_vm.$t("common.No")))
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: item.seckill,
                                  expression: "item.seckill"
                                }
                              ],
                              attrs: {
                                label: _vm.$t("common.Secondkillsorting"),
                                "label-width": _vm.formLabelWidth
                              }
                            },
                            [
                              _c("el-input", {
                                staticClass: "input-width",
                                attrs: {
                                  oninput:
                                    "value=value.replace(/[^0-9]/g,'');if(value && value.length>9)value=value.slice(0,9)",
                                  placeholder: _vm.$t(
                                    "common.Topwithlargenumbers"
                                  )
                                },
                                model: {
                                  value: item.sort,
                                  callback: function($$v) {
                                    _vm.$set(item, "sort", $$v)
                                  },
                                  expression: "item.sort"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "common.Purchaserestrictionsforthesameuser"
                                ),
                                prop: "userRestrictions",
                                "label-width": _vm.formLabelWidth
                              }
                            },
                            [
                              _c("el-input", {
                                staticClass: "input-width",
                                attrs: {
                                  oninput:
                                    "value=value.replace(/[^0-9]/g,'');if(value && value.length>9)value=value.slice(0,9)",
                                  placeholder: _vm.$t(
                                    "common.PleaseEnterThePurchaseLimitForTheSameUser"
                                  )
                                },
                                on: {
                                  blur: function($event) {
                                    return _vm.handleOrderPurchaseLimit(item)
                                  }
                                },
                                model: {
                                  value: item.userRestrictions,
                                  callback: function($$v) {
                                    _vm.$set(item, "userRestrictions", $$v)
                                  },
                                  expression: "item.userRestrictions"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("common.Singleorderlimit"),
                                prop: "orderRestrictions",
                                "label-width": _vm.formLabelWidth
                              }
                            },
                            [
                              _c("el-input", {
                                staticClass: "input-width",
                                attrs: {
                                  oninput:
                                    "value=value.replace(/[^0-9]/g,'');if(value && value.length>9)value=value.slice(0,9)",
                                  placeholder: _vm.$t(
                                    "common.PleaseEnterThePurchaseLimitForASingleOrder"
                                  )
                                },
                                on: {
                                  blur: function($event) {
                                    return _vm.handleOrderPurchaseLimit(item)
                                  }
                                },
                                model: {
                                  value: item.orderRestrictions,
                                  callback: function($$v) {
                                    _vm.$set(item, "orderRestrictions", $$v)
                                  },
                                  expression: "item.orderRestrictions"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                }),
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }